import { InputSwitch as PrimeInputSwitch } from 'primereact/inputswitch';
import type { InputSwitchProps as PrimeInputSwitchProps } from 'primereact/inputswitch';

export interface InputSwitchProps extends Omit<PrimeInputSwitchProps, 'checked'> {
  testId?: string;
  label?: string;
  checked?: boolean;
}

export const InputSwitch = ({ testId, label, checked, className, ...props }: InputSwitchProps) => {
  const control = (
    <PrimeInputSwitch
      {...({ 'data-testid': testId } as any)}
      checked={!!checked}
      className={className}
      {...props}
    />
  );

  if (!label) {
    return control;
  }

  return (
    <span className="inline-flex items-center gap-2">
      {control}
      <span className="text-sm">{label}</span>
    </span>
  );
};

export default InputSwitch;
